<template>
  <div><h1>Hiding image into another image</h1>
    
  </div>
</template>

<script>
export default {
    name:"InfoHead"
}
</script>

<style scoped>
    div{
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        padding-bottom: 0px;
    }

    h1{
        font-size: 30px;
        padding: 10px;
    }
</style>